module.exports = __webpack_public_path__ + "img/img-area-digital-banner.048546cc.png";